import React from "react";

export function SectionLabel({ number, label }) {
    return (
        <div className="flex items-center gap-3 mb-6" data-testid="section-label">
            <span className="section-dot" />
            <span className="font-mono-tech text-xs text-white/60 tracking-[0.22em] uppercase">
                {number ? `${number} / ` : ""}{label}
            </span>
        </div>
    );
}
